import { Pipe, PipeTransform } from '@angular/core';
import { TimeObject, TimeSpan } from '../helpers/time-span';

@Pipe({
    name: 'stringToTimeObject',
    standalone: false
})
export class StringToTimeObjectPipe implements PipeTransform {

  transform(timeString: string): TimeObject | null {
    return timeString ? TimeSpan.parse(timeString).getAsTimeObject() : null;
  }

}
